import React, { useState } from 'react';
import { Avatar, Flex, View, Box, Text, Modal, Button, VStack, useTheme } from 'native-base';
import { MODAL_WIDTH } from '../../../Constants';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { profileAPI, useProfileState, useProfileDispatch } from '../../../../context/profile';
import { useAuthState } from '../../../../context/auth';
import { useEnvState } from '../../../../context/env';
import { getFriendlyOrDiscourseUsername } from '../../../utils/helpers';
const UserProfileModal = props => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const profileState = useProfileState();
  const profileDispatch = useProfileDispatch();
  const profileUser = props.profileUser;
  const setShow = props.setShowUserProfileModal;
  const isOpen = props.showUserProfileModal;
  const getUserFromContext = id => {
    const profileStateUsers = profileState.users;
    const user = profileStateUsers.find(item => item.id === id);
    return user;
  };
  const addNewUser = newUser => {
    const newUsers = [...profileState.users];
    newUsers.push(newUser);
    profileDispatch({
      type: 'SET_USERS',
      payload: newUsers
    });
  };
  const [userWithProfile, setUserWithProfile] = useState({});
  const getUserFromContextOrAPI = async () => {
    const userFromContext = getUserFromContext(profileUser.id);
    if (!userFromContext) {
      const envState = useEnvState();
      const authState = useAuthState();
      const platformAuthToken = authState === null || authState === void 0 ? void 0 : authState.platform_user.authToken;
      const platformIdFromUsername = profileUser !== null && profileUser !== void 0 && profileUser.username ? profileUser.username.split('.')[1] : null;
      const profile = await profileAPI.getUserProfile(envState.api_url, platformIdFromUsername, platformAuthToken);
      if (profile) {
        const user = {
          id: profileUser.id,
          platform_user: profile
        };
        addNewUser(user);
        setUserWithProfile(user);
      }
    }
  };
  getUserFromContextOrAPI();
  const closeModal = () => {
    setShow(false);
  };
  const getGoal = () => {
    const fieldValue = userWithProfile.platform_user['goal'];
    if (!fieldValue) return null;else {
      return /*#__PURE__*/React.createElement(VStack, null, /*#__PURE__*/React.createElement(Text, {
        fontSize: 'sm'
      }, "#1 biggest goal in joining WHOLE Life Club"), /*#__PURE__*/React.createElement(Text, {
        fontSize: 'sm'
      }, fieldValue));
    }
  };
  const getUserName = () => {
    const platformUser = userWithProfile.platform_user;
    const hasKeys = !!Object.keys(platformUser).length;
    let userName = getFriendlyOrDiscourseUsername(profileUser, 'friendly');
    if (hasKeys) {
      userName = platformUser.firstName + (platformUser.lastName && ` ${platformUser.lastName.slice(0, 1)}.`);
    }
    return userName;
  };
  const getUserAddress = () => {
    const fieldValue = userWithProfile.platform_user['public'];
    if (!fieldValue) return null;else {
      let address = '';
      if (fieldValue.city && fieldValue.city.length) address += fieldValue.city;
      if (fieldValue.state && fieldValue.state.length) {
        if (address.length) address += ', ';
        address += fieldValue.state;
      }
      if (fieldValue.country && fieldValue.country.length) {
        if (address.length) address += ' ';
        address += fieldValue.country;
      }
      return /*#__PURE__*/React.createElement(Text, {
        fontSize: 'sm'
      }, address);
    }
  };
  if (!userWithProfile || !userWithProfile.platform_user) return null;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onClose: () => setShow(false),
    size: MODAL_WIDTH,
    w: "container",
    h: "80vh"
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Modal.Body, {
    bg: colors.modal.bg
  }, /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: {
      base: 'column',
      lg: 'row'
    },
    m: 5
  }, /*#__PURE__*/React.createElement(Box, {
    w: {
      base: '100%',
      lg: '33%'
    }
  }, profileUser.avatar_template ? /*#__PURE__*/React.createElement(Avatar, {
    source: {
      uri: profileUser.avatar_template
    },
    size: 140,
    borderRadius: '50%',
    bg: colors.userProfileModal.avatar.bg
  }, "User Profile Image") : /*#__PURE__*/React.createElement(View, {
    size: 140,
    borderRadius: '50%',
    bg: colors.userProfileModal.avatar.bg,
    alignItems: "center",
    justifyItems: "center",
    pt: 6
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faUser,
    color: colors.userProfileModal.avatar.icon,
    size: 80
  }))), /*#__PURE__*/React.createElement(Box, {
    w: {
      base: '100%',
      lg: '67%'
    },
    p: 6,
    alignItems: {
      base: 'center',
      lg: 'left'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: '2xl',
    fontWeight: "bold"
  }, getUserName()), getUserAddress(), getGoal())))), /*#__PURE__*/React.createElement(Modal.Footer, {
    bg: colors.modal.bg,
    borderTopWidth: 1,
    borderTopColor: colors.userProfileModal.footer.border
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "unstyled",
    _hover: {
      bg: colors.userProfileModal.button.hover
    },
    bg: colors.userProfileModal.button.bg,
    onPress: () => closeModal()
  }, "Close"))));
};
export default UserProfileModal;
//# sourceMappingURL=UserProfileModal.js.map